<template>
  <v-container grid-list-md pa-0 ma-2 style="max-width: calc(100% - 16px)">
    <v-toolbar flat class="mb-2">
      <v-btn icon @click="$router.back()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title>Abordagens de Incentivo</v-toolbar-title>
    </v-toolbar>

    <v-layout
      v-if="incentiveApproachUtils && incentiveApproach.approach_type"
      column
      align-center
      justify-center
      wrap>
      <p class="title mt-2 mb-2">
        Mensagens da abordagem de incentivo (<b>{{ incentiveApproachCreditorName }}</b
        >)
      </p>
      <div class="d-flex align-center mb-2">
        <span :class="`mr-1 tag-approach-type  ${incentiveApproach.approach_type}`">
          {{ incentiveApproachUtils.type[incentiveApproach.approach_type].name }}
        </span>
        <span :class="`small chip-incentive-step  ${incentiveApproach.incentive_step}`">
          {{ incentiveApproachUtils.step[incentiveApproach.incentive_step].name }}
        </span>
      </div>
    </v-layout>

    <v-layout align-center justify-center wrap>
      <!--SMS-->
      <v-flex
        xs12
        :class="!messages.length ? '' : 'mb-4'"
        v-if="incentiveApproach.approach_type == 'INCENTIVE_SMS'">
        <h2 v-if="!messages.length" class="text-xs-center font-weight-regular">
          Nenhum SMS cadastrado.
        </h2>
        <v-list three-line subheader>
          <v-list-tile v-for="(item, index) in messages" :key="index" class="item-content">
            <v-list-tile-content>
              {{ item.content }}

              <div v-if="item.offer_type" class="item-offer-type">
                Tipo da Oferta:
                <span class="item-offer-type-description">
                  {{ item.offer_type.description }}
                </span>
              </div>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn ripple icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(menu, i) in menuItens"
                    :key="i"
                    @click="clickItemAction(item, index, menu.action)">
                    <v-list-tile-title>{{ menu.label }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>

      <!--PUSH-->
      <v-flex
        xs12
        :class="!pushs.length ? '' : 'mb-4'"
        v-if="incentiveApproach.approach_type == 'INCENTIVE_PUSH'">
        <h2 v-if="!pushs.length" class="text-xs-center font-weight-regular">
          Nenhum push cadastrado.
        </h2>
        <v-list three-line subheader>
          <v-list-tile v-for="(item, index) in pushs" :key="index" class="item-content">
            <v-list-tile-content>
              <div class="font-weight-bold">{{ item.title }}</div>
              <div>{{ item.body }}</div>

              <div v-if="item.offer_type" class="item-offer-type">
                Tipo da Oferta:
                <span class="item-offer-type-description">
                  {{ item.offer_type.description }}
                </span>
              </div>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn ripple icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(menu, i) in menuItens"
                    :key="i"
                    @click="clickItemAction(item, index, menu.action)">
                    <v-list-tile-title>{{ menu.label }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>

      <!--EMAIL-->
      <v-flex
        xs12
        :class="!emails.length ? '' : 'mb-4'"
        v-if="incentiveApproach.approach_type == 'INCENTIVE_EMAIL'">
        <h2 v-if="!emails.length" class="text-xs-center font-weight-regular">
          Nenhum e-mail cadastrado.
        </h2>
        <v-list three-line subheader>
          <v-list-tile v-for="(item, index) in emails" :key="index" class="item-content">
            <v-list-tile-content>
              <v-layout class="pa-0 ma-0" justify-space-between align-center row wrap>
                <div class="font-weight-bold">{{ item.subject }}</div>
                <div class="ml-5">
                  <a :href="item.template_url" target="_blank">
                    {{ item.template_url }}
                  </a>
                </div>
              </v-layout>

              <div v-if="item.offer_type" class="item-offer-type">
                Tipo da Oferta:
                <span class="item-offer-type-description">
                  {{ item.offer_type.description }}
                </span>
              </div>

              <iframe
                class="pa-0 ma-0"
                v-if="item.content"
                :srcdoc="item.content"
                scrolling="no"
                height="30"
                frameBorder="0"
                width="100%"
                src="demo_iframe_srcdoc.htm"></iframe>

              <v-layout row wrap> </v-layout>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn ripple icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(menu, i) in menuItens"
                    :key="i"
                    @click="clickItemAction(item, index, menu.action)">
                    <v-list-tile-title>{{ menu.label }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>

      <!--WHATSAPP-->
      <v-flex
        xs12
        :class="!whatsapp_messages.length ? '' : 'mb-4'"
        v-if="incentiveApproach.approach_type == 'INCENTIVE_WHATSAPP'">
        <h2 v-if="!whatsapp_messages.length" class="text-xs-center font-weight-regular">
          Nenhum whatsapp cadastrado.
        </h2>
        <v-list subheader>
          <v-list-tile v-for="(item, index) in whatsapp_messages" :key="index" class="item-content">
            <v-list-tile-content>
              <div v-if="item.initiative" style="width: 100%; padding: 6px 0" class="approach-flow-initiative">
                <p>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <span class="font-weight-bold">{{ item.initiative.name }}</span>
                        [ <i>{{ item.initiative.key }}</i> ]
                      </span>
                    </template>
                    <span>Nome e chave da iniciativa WhatsApp</span>
                  </v-tooltip>

                  <span
                    v-if="item.initiative.meta_status"
                    :class="[item.initiative.meta_status, item.initiative.meta_quality_score]"
                    class="initiative_selector_initiative--status mr-1">
                    {{ item.initiative.meta_status | whatsappTemplateStatus }}
                  </span>

                  <QualityChip
                    v-if="item.initiative.meta_status == 'APPROVED'"
                    :quality="item.initiative.meta_quality_score || null"
                  ></QualityChip>

                  <v-tooltip bottom v-if="item.initiative.creditor_id">
                    <template v-slot:activator="{ on }">
                      <span class="ml-2" v-on="on"> ★ </span>
                    </template>
                    <span>Template exclusivo para este credor</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-chip class="py-0 my-0" small dense outline>
                          <span v-if="item.initiative.meta_category === 'MARKETING'">Marketing</span>
                          <span v-else-if="item.initiative.meta_category === 'UTILITY'">Utilidade</span>
                          <span v-else-if="item.initiative.meta_category === 'AUTHENTICATION'">Autenticação</span>
                          <span v-else>{{ item.initiative.meta_category }}</span>
                        </v-chip>
                      </span>
                    </template>
                    <span>Categoria do template no WhatsApp</span>
                  </v-tooltip>

                  <ApprovalIcon
                    :approved="item.initiative.approved"
                    :approvedBy="item.initiative.approved_by"
                    :approvedAt="item.initiative.approved_at"
                  ></ApprovalIcon>
                </p>

                <p>
                  <v-tooltip bottom v-if="item.initiative.sender">
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <i>#{{ item.initiative.sender.id }}</i>
                        {{ item.initiative.sender.phone_number | phoneNumber }}
                      </span>
                    </template>
                    <span>Número do WhatsApp Business que enviará a mensagem</span>
                  </v-tooltip>

                  <v-tooltip bottom v-if="item.initiative.sender && item.initiative.sender.meta_quality_rating_v2">
                    <template v-slot:activator="{ on }">
                      <span
                        v-on="on"
                        class="initiative_selector_sender--status"
                        :class="[item.initiative.sender.meta_quality_rating_v2]">
                        {{ item.initiative.sender.meta_quality_rating_v2 | whatsappSenderQuality }}
                      </span>
                    </template>
                    <span>Classificação de qualidade do remetente no Meta/WhatsApp</span>
                  </v-tooltip>

                  <FlaggedIcon
                    v-if="item.initiative.sender && item.initiative.sender.meta_status === 'FLAGGED'"
                  />
                </p>
              </div>

              <div v-if="item.offer_type" class="item-offer-type">
                Tipo da Oferta:
                <span class="item-offer-type-description">
                  {{ item.offer_type.description }}
                </span>
              </div>

              <v-layout row wrap> </v-layout>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn ripple icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(menu, i) in menuItens"
                    :key="i"
                    @click="clickItemAction(item, index, menu.action)">
                    <v-icon class="mr-1">{{ menu.icon }}</v-icon>
                    <v-list-tile-title>{{ menu.label }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>

    <v-btn color="accent" fixed bottom right fab @click="openCreateDialog">
      <v-icon>add</v-icon>
    </v-btn>

    <ConfigureMessagesDialog
      :configureMessagesDialog.sync="dialogMessages"
      :approach="incentiveApproach.approach"
      :creditor-id="incentiveApproach.creditor_id"
      :incentiveApproachType="incentiveApproachType"
      :links="links"
      :offerTypes="offerTypes"
      :variables="variables"
      :editItemData="editItemData"
      @add="handleAdd"
      @update="handleUpdate" />

    <ConfirmDialog @removeData="removeData" :dialogConfirm="dialogConfirm" />

    <v-snackbar v-model="show_snack" :timeout="0" :top="true">
      {{ snack_text }}
      <v-btn flat icon color="error" @click.stop="show_snack = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

//utils
import variables from "@/utils/message-variables";
import incentiveApproachUtils from "@/utils/incentive-approach";

//services
import offerService from "@/services/offer";
import approachService from "@/services/approach";
import creditorService from "@/services/creditor";
import ConfirmDialog from "./components/ConfirmDialog.vue";

//components
import FlaggedIcon from "@/components/ui/FlaggedIcon.vue";
import QualityChip from "@/components/ui/QualityChip.vue";
import ApprovalIcon from "@/components/ui/ApprovalIcon.vue";
import ConfigureMessagesDialog from "./components/ConfigureMessagesDialog.vue";

export default {
  components: {
    ConfirmDialog,
    ConfigureMessagesDialog,
    FlaggedIcon,
    QualityChip,
    ApprovalIcon,
  },
  data: () => ({
    incentiveApproachUtils,
    show_snack: false,
    snack_text: "",
    alert: true,
    dialogMessages: false,
    editItem: false,
    switchShow: false,
    dialogConfirm: false,
    contentLength: 0,
    pushs: [],
    emails: [],
    whatsapp_messages: [],
    messages: [],
    offerTypes: [],
    variables_array: [],
    links: ["$LINK", "$LINK_REDIRECT", "$LINK_WHATSAPP", "$LINK_FOMENTATION", "$LINK_ME_LEMBRE"],
    menuItens: [
      {
      label: "Editar",
      action: "edit",
      icon: "mdi-pencil",
      },
      {
      label: "Excluir",
      action: "delete",
      icon: "mdi-delete",
      },
    ],
    waitingToBeDeleted: null,
    currentEditItemIndex: null,
    editItemData: null,
    incentiveApproachType: {
      name: "",
      color: "",
      value: "",
    },
    creditors: [],
    incentiveApproach: {},
  }),

  async created() {
    await this.getCreditors();
    await this.getOfferType();

    this.incentiveApproach = await this.getIncentiveApproach(
      this.$route.params.incentive_approach_id
    );

    this.variables_array = variables.variables;

    if (this.incentiveApproach.approach_type) {
      this.incentiveApproachType =
        incentiveApproachUtils.type[this.incentiveApproach.approach_type];
    }

    this.loadDataField();
  },

  computed: {
    incentiveApproachCreditorName() {
      if (!this.incentiveApproach.creditor_id || !this.creditors.length)
        return "Credor não informado";

      let creditor = this.creditors.find(
        (c) => c.creditor_id == this.incentiveApproach.creditor_id
      );

      return creditor ? creditor.name : "Não informado";
    },

    variables() {
      if (!this.incentiveApproach.creditor_id || !this.creditors.length) return [];

      let allowed_variables =
        this.creditors.find((c) => c.creditor_id == this.incentiveApproach.creditor_id)
          .allowed_variables || [];

      if (!allowed_variables.length) return this.variables_array;

      return this.variables_array.filter((item) => allowed_variables.includes(item.name));
    },
  },

  watch: {
    dialogMessages() {
      if (!this.dialogMessages) {
        setTimeout(() => {
          this.editItem = false;
          this.editItemData = null;
        }, 500);
      }
    },
  },

  methods: {
    ...mapActions("incentiveApproach", ["getIncentiveApproach", "editIncentiveApproach"]),

    async getCreditors() {
      await creditorService
        .list()
        .then((res) => {
          this.creditors = [...res.objects];
        })
        .catch((err) => console.error(err));
    },

    async getOfferType() {
      await offerService
        .list()
        .then((res) => (this.offerTypes = res))
        .catch((err) => console.error(err));
    },

    async loadDataField() {
      if (this.incentiveApproach.approach.messages) {
        if (this.incentiveApproach.approach_type == "INCENTIVE_SMS") {
          this.messages = this.incentiveApproach.approach.messages;
        } else if (this.incentiveApproach.approach_type == "INCENTIVE_PUSH") {
          this.pushs = this.incentiveApproach.approach.messages;
        } else if (this.incentiveApproach.approach_type == "INCENTIVE_EMAIL") {
          this.emails = this.incentiveApproach.approach.messages;
        } else if (this.incentiveApproach.approach_type == "INCENTIVE_WHATSAPP") {
          this.whatsapp_messages = this.incentiveApproach.approach.messages;
        }
      }
    },

    save() {
      if (!this.$refs.form.validate()) return;

      approachService
        .save({
          id: this.incentiveApproach.approach.id,
          name: this.incentiveApproach.approach.name,
          creditor_id: this.incentiveApproach.creditor_id,
          notify_type: this.incentiveApproach.approach.notify_type,
        })
        .then((res) => {
          if (res == undefined) {
            this.$store.commit("showSnackbar", {
              message: "Houve um erro ao salvar",
            });
          } else {
            this.$store.commit("showSnackbar", {
              message: "Abordagem salva com sucesso!",
              important: true,
            });
            this.incentiveApproach.approach = res;
          }
        })
        .catch((error) => {
          this.$store.commit("showSnackbar", {
            message: "Houve um erro ao salvar",
          });
        });
    },

    clickItemAction(item, itemIndex, action) {
      if (action == "delete") {
        this.waitingToBeDeleted = {
          index: itemIndex,
          item: item,
        };
        this.dialogConfirm = true;
      } else {
        this.editData(item, itemIndex);
      }
    },

    editData(item, itemIndex) {
      this.dialogMessages = true;
      this.editItem = true;
      this.currentEditItemIndex = itemIndex;
      this.editItemData = { item: item, index: itemIndex };
    },

    async removeData() {
      let type = "";
      let array = "";
      if (this.incentiveApproach.approach_type == "INCENTIVE_SMS") {
        type = "sms";
        array = "messages";
      } else if (this.incentiveApproach.approach_type == "INCENTIVE_PUSH") {
        type = "push";
        array = "pushs";
      } else if (this.incentiveApproach.approach_type == "INCENTIVE_EMAIL") {
        type = "email";
        array = "emails";
      } else if (this.incentiveApproach.approach_type == "INCENTIVE_WHATSAPP") {
        type = "whatsapp";
        array = "whatsapp_messages";
      }

      approachService[type](null, this.waitingToBeDeleted.item.id)
        .then(
          () => (this[array] = this[array].filter((e, i) => i !== this.waitingToBeDeleted.index))
        )
        .catch((err) => {
          console.error(err);
          alert("Não foi possível excluir a mensagem");
        });
      this.dialogConfirm = false;

      const id = this.$route.params.incentive_approach_id;
      if (id) await this.editIncentiveApproach({ id });
    },

    async handleAdd({ type, payload }) {
      try {
        const resp = await approachService[type](payload);

        const id = this.$route.params.incentive_approach_id;
        if (id) await this.editIncentiveApproach({ id });

        this.incentiveApproach.approach.messages.push(resp);
        this.loadDataField();
      } catch (err) {
        console.error(err);
        this.$store.commit("showSnackbar", {
          message: "Não foi possível salvar a mensagem",
        });
      }
    },

    async handleUpdate({ type, payload, id, index }) {
      try {
        const resp = await approachService[type](payload, id);

        const idIncentive = this.$route.params.incentive_approach_id;
        if (idIncentive) await this.editIncentiveApproach({ id: idIncentive });

        this.incentiveApproach.approach.messages.forEach((item, idx) => {
          if (item.id == id) {
            this.incentiveApproach.approach.messages[idx] = Object.assign(item, resp);
          }
        });
        this.loadDataField();
        this.currentEditItemIndex = null;
        this.editItem = false;
        this.editItemData = null;
      } catch (err) {
        console.error(err);
        this.$store.commit("showSnackbar", {
          message: "Não foi possível salvar a mensagem",
        });
      }
    },

    openCreateDialog() {
      this.editItem = false;
      this.editItemData = null;
      this.dialogMessages = true;
    },
  },
};
</script>

<style>
.item-content {
  margin: 10px 0px;
  padding: 5px 2px;
  border-color: #d3d3d3;
  border-style: dashed;
  border-width: 2px;
  border-radius: 10px;
}

.var_content {
  border-radius: 12px;
  padding: 2px 0px;
}

.var_container {
  max-height: 600px;
  overflow: auto;
}

.item-offer-type {
  color: gray;
  font-size: 14px;
  margin-top: 4px;
}

.item-offer-type-description {
  font-weight: 500;
}

.approach-flow-initiative p {
  margin-bottom: 4px;
}

.approach-flow-initiative .initiative_selector_initiative--status {
  border: 1px solid;
  border-radius: 2px;
  font-weight: 500;
  padding: 1px 2px;
  white-space: nowrap;
  font-size: 12px;
}

.approach-flow-initiative .initiative_selector_initiative--status.APPROVED {
  background-color: #ebf5f1;
  border-color: #b6d1c6;
  color: #247058;
}

.approach-flow-initiative .initiative_selector_initiative--status.APPROVED.LOW {
  background-color: #fff0f1;
  border-color: #facfd4;
  color: #ab1628;
}

.approach-flow-initiative .initiative_selector_initiative--status.APPROVED.MEDIUM {
  background-color: #fff8e3;
  border-color: #ffe299;
  color: #ad7410;
}

.approach-flow-initiative .initiative_selector_initiative--status.PENDING_DELETION,
.approach-flow-initiative .initiative_selector_initiative--status.REJECTED {
  background-color: #fff0f1;
  border-color: #facfd4;
  color: #ab1628;
}

.approach-flow-initiative .initiative_selector_initiative--status.DISABLED,
.approach-flow-initiative .initiative_selector_initiative--status.UNKNOWN {
  background-color: #e5e5e3;
  border-color: #a6a5a2;
  color: #545452;
}

/* Custom design for paused states */
.approach-flow-initiative .initiative_selector_initiative--status.PAUSED,
.approach-flow-initiative .initiative_selector_initiative--status.FIRST_PAUSED,
.approach-flow-initiative .initiative_selector_initiative--status.SECOND_PAUSED {
  background-color: #fff3e0;
  border-color: #ffcc80;
  color: #e65100;
}

.item-content .v-list__tile {
  height: auto !important;
}

</style>
